import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5be3154a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "banner-wrapper"
};
const _hoisted_2 = {
  class: "content-wrapper"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("The First Alliance");

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" The First Alliance aims to collaboratively use resources and core competencies to facilitate the needs of NFT holders, expand the ranges of product utilities and develop better communities. ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_content_text = _resolveComponent("content-text");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_content_text, {
    center: true
  }, {
    title: _withCtx(() => [_hoisted_3]),
    content: _withCtx(() => [_hoisted_4]),
    _: 1
  })])]);
}